import z from 'zod'

/**
 * Shared search-param schema for all `/arc/profile` consumers.
 * Defines the association context, active tab, and optional call selection state.
 */
export const arcProfileSearchSchema = z.object({
  associatedId: z.string().optional(),
  associatedType: z.enum(['AUTHORITY', 'SCHEME', 'SERVICE_USER', 'DEVICE']).optional(),
  associatedName: z.string().optional(),
  tabIndex: z.number().int().optional(),
  mainCallId: z.string().optional(),
  mainCallSessionId: z.string().optional(),
  currentCallSessionId: z.string().optional(),
  direction: z.string().optional(),
  outsideNumber: z.string().optional(),
})

export type ArcProfileSearch = z.infer<typeof arcProfileSearchSchema>
